module.exports = __webpack_public_path__ + "img/505.01d9b406.jpg";